import { configureStore } from "@reduxjs/toolkit";
import applicationReducer from "./applicationSlice";

const store = configureStore({
  reducer: {
    application: applicationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
